function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 22.5,
  fill: "#DEF4EC",
  stroke: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.7705 17.3374C17.0634 17.3374 18.1152 18.1639 18.1152 19.2913H20.5205C20.5205 17.0364 18.3897 15.333 15.7705 15.333C13.1513 15.333 11.0205 17.0364 11.0205 19.2913H13.4258C13.4258 18.1639 14.4778 17.3374 15.7705 17.3374Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.0205 17.3374C31.3134 17.3374 32.3652 18.1639 32.3652 19.2913H34.7705C34.7705 17.0364 32.6397 15.333 30.0205 15.333C27.4013 15.333 25.2705 17.0364 25.2705 19.2913H27.6758C27.6758 18.1639 28.7277 17.3374 30.0205 17.3374Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.8553 33.541C27.2923 33.541 31.5445 31.3206 33.9792 27.6341L32.0528 26.416C29.8172 29.8013 25.7265 31.6907 21.6328 31.2282C18.4418 30.8681 15.4908 29.0691 13.7387 26.416L11.8125 27.6341C13.9325 30.8446 17.5055 33.0215 21.37 33.4576C21.8661 33.5137 22.3615 33.541 22.8553 33.541Z",
  fill: "#1ECD96"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  x: 11.0205,
  y: 15.333,
  width: 23.9583,
  height: 18.2083,
  fill: "white"
})));

var SvgDefaultUserIcon = function SvgDefaultUserIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefaultUserIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/default_user_icon.a7f3ee33.svg";
export { ForwardRef as ReactComponent };